import { CurrencySelector } from "@adoptaunabuelo/react-components";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { actionsCreators, State } from "../../redux";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "@reduxjs/toolkit";

const CurrencySelectorElement = () => {
	const dispatch = useDispatch();
	const { setAppLocation } = bindActionCreators(actionsCreators, dispatch);

	const appLocation = useSelector((state: State) => state.location.location);
	const config = useSelector((state: State) => state.location.config);
	const isMobile = useSelector((state: State) => state.screen.isMobile);

	const [currencyOptions, setCurrencyOptions] = useState<
		{ name: string; symbol: string; currency: string }[]
	>([]);

	useEffect(() => {
		if (config && config.attributes && config.attributes.VALID_CURRENCIES) {
			const currencies = config.attributes.VALID_CURRENCIES.map(
				(item: any) => {
					return {
						currency: item.name,
						name: item.title,
						symbol: item.symbol,
					};
				}
			);
			setCurrencyOptions(currencies);
		}
	}, []);

	const onCurrencyChange = (currency: any) => {
		//Get new currency object
		const newCurrency = config.attributes.VALID_CURRENCIES.find(
			(item: any) => item.name === currency.currency
		);
		const tempAppLocation = {
			...appLocation,
			currency: {
				...newCurrency,
				name: newCurrency.name.toLocaleLowerCase(),
				isVerified: true,
				hasSEPA:
					newCurrency.name.toLocaleLowerCase() === "eur"
						? true
						: false,
			},
		};
		setAppLocation(tempAppLocation as any);
		localStorage.setItem(
			"navigationProperties",
			JSON.stringify(tempAppLocation)
		);
	};

	return (
		<CurrencySelector
			style={
				isMobile
					? { boxShadow: "none", height: 38, alignItems: "center", padding: "0px 10px" }
					: {}
			}
			options={currencyOptions}
			selectedOption={{
				currency: appLocation
					? appLocation.currency.name.toUpperCase()
					: "EUR",
				symbol: appLocation ? appLocation.currency.symbol : "€",
				name: "",
			}}
			onChange={onCurrencyChange}
		/>
	);
};
export default CurrencySelectorElement;
